import React from 'react';
import AddBookForm from '../AddBookForm';

const FirstBookStep = ({ onNext }) => (
  <div className="mx-auto max-w-xl py-16">
    <p className="label">FIRST BOOK</p>
    <h2 className="mt-6 font-display text-3xl sm:text-4xl leading-tight text-ink-900 dark:text-ink-50">
      첫 책을 등록해보세요
    </h2>
    <p className="mt-4 text-base leading-relaxed text-ink-600 dark:text-ink-300 font-sans">
      지금 읽고 있는 책이면 가장 좋아요. 나중에 얼마든지 바꿀 수 있습니다.
    </p>

    <div className="mt-10 border-t border-ink-200 dark:border-ink-800 pt-10">
      <AddBookForm onAddBook={onNext} />
    </div>

    <div className="mt-6 text-center">
      <button
        onClick={() => onNext(null)}
        className="text-sm text-ink-500 dark:text-ink-400 underline underline-offset-4 hover:text-ink-900 dark:hover:text-ink-50 transition-colors font-sans"
      >
        나중에 등록할게요
      </button>
    </div>
  </div>
);

export default FirstBookStep;
